<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      append-to-body
      class="job-apply-dialog"
      :before-close="handleClose"
      width="760px"
    >
      <div>
        <h1>{{ workflowTitle }}</h1>
        <table class="details-table" cellpadding="0" cellspacing="0">
          <tr v-if="!isApply">
            <td class="header">{{ $t('CargoMsg.Cargo_ApprovalSerialNumber') }}</td>
            <td class="values">{{ processInfo.documentProcessNo }}</td>
            <td class="header">{{ $t('CargoMsg.Cargo_StartDate') }}</td>
            <td class="values">{{ processInfo.createDate }}</td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_Applicant') }}</td>
            <td class="values">{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', isApply ? $store.getters.userId : processInfo.creatorId, 'chineseName') }}</td>
            <td class="header">{{ $t('CargoMsg.Cargo_InitiateBranchCompany') }}</td>
            <td class="values">{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', job.opOffice, 'chineseName') }}</td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_BusinessNo') }}</td>
            <td class="values">{{ job.jobNo }}</td>
            <td class="header">{{ $t('CargoMsg.Cargo_BusinessType') }}</td>
            <td class="values">{{ lobLabel() }}</td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_TotalReceivable') }}</td>
            <td class="values">{{ job.totalReceivable + 'RMB' }}</td>
            <td class="header">{{ $t('CargoMsg.Cargo_TotalDues') }}</td>
            <td class="values">{{ job.totalDues + 'RMB' }}</td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_GrossMargin') }}</td>
            <td style="font-size: 14px; color: red" class="values">{{ job.grossProfit + '%' }}</td>
            <td class="header">{{ $t('CargoMsg.Cargo_PackingType') }}</td>
            <td class="values">{{ getLoadTypeLabel() }}</td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_StartingPort') }}</td>
            <td class="values">{{ getLoadingPortLabel() }}</td>
            <td class="header">{{ $t('CargoMsg.Cargo_PortOfDischarge') }}</td>
            <td class="values">{{ getDischargingPortLabel() }}</td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_Remarks') }}</td>
            <td class="values">{{ job.remarks }}</td>
          </tr>
        </table>
        <div v-if="!isApply" style="margin-top: 20px; margin-bottom: 20px; width: 100%; height: 30px">
          <el-button style="float: right" type="primary" @click="onViewChargeRequest">{{ $t('CargoMsg.Cargo_ViewChargeDetails') }}</el-button>
        </div>
        <div v-if="!isApply" style="border: 1px solid #E3E3E3;">
          <div style="margin: 5px">
            <el-tabs v-model="activeName">
              <el-tab-pane v-if="isApprove" :label="$t('CargoMsg.Cargo_ApprovalComments')" name="comments">
                <process-content :form="form" />
              </el-tab-pane>
              <el-tab-pane :label="$t('CargoMsg.Cargo_ApprovalCommentsRecord')" name="record">
                <div style="max-height: 130px; overflow: auto">
                  <div v-for="(record, index) in records" :key="index">
                    <el-card class="box-card">
                      <div v-if="record.actionType !== 7000" style="display: flex">
                        <span>{{ $t('CargoMsg.Cargo_Approver') }}： </span>
                        <span>{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', record.userId, 'chineseName') }}</span>
                        <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_ApprovalComments') }}： </span>
                        <span>{{ WorkflowUtil.getActionName(record.actionType) }}</span>
                        <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_Remarks') }}： </span>
                        <span>{{ record.remark }}</span>
                        <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_ApprovalTime') }}： </span>
                        <span>{{ record.createTime }}</span>
                      </div>
                      <div v-else style="display: flex">
                        <span>{{ $t('CargoMsg.Cargo_Initiator') }}： </span>
                        <span>{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', record.userId, 'chineseName') }}</span>
                        <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_Remarks') }}： </span>
                        <span>{{ record.remark }}</span>
                        <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_StartTime') }}： </span>
                        <span>{{ record.createTime }}</span>
                      </div>
                      <div v-show="record.files && record.files.length > 0" style="margin-top: 10px;cursor: pointer;">
                        <div v-for="(file, index) in record.files" :key="index" style="display: inline-block;" class="file-style">
                          <div style="margin-left: 10px; display: flex" @click="downloadFile(file.fileId)">
                            <i class="el-icon-paperclip" />
                            <span class="file-name">{{ file.fileName }}</span>
                            <span style="color: darkgray;">{{ WorkflowUtil.fileSizeLabel(file.fileSize) }}</span>
                          </div>
                        </div>
                      </div>
                    </el-card>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div v-if="isApply && hasBtn" style="margin-top: 10px; margin-bottom: 10px">
          <span style="margin-left: 10px">{{ $t('CargoMsg.Cargo_Remarks') }}:</span>
          <process-content :form="form" />
        </div>
        <charge-dialog
          :visible.sync="showChargeDialog"
          :job="job"
          @close="showChargeDialog=false"
        />
      </div>
      <template slot="footer" style="height: 65px">
        <div style="display: flex">
          {{ $t('CargoMsg.Cargo_RefuseAndReturnNode') }}
        </div>
        <div style="float: right; display: flex">
          <el-button v-for="(btn, index) in btnList" :key="index" :title="btn.title" :type="btn.color" @click="onAction(btn)">{{ btn.actionName }}</el-button>
          <el-button @click="handleClose">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </div>
      </template>
    </el-dialog>
    <!-- 加签 人员配置 -->
    <choose-user-dialog-add
      v-if="chooseUserDialogAdd.visible"
      :title="$t('CargoMsg.Cargo_SelectSigner')"
      :visible.sync="chooseUserDialogAdd.visible"
      :value="chooseUserDialogAdd.userIds"
      @close="chooseUserDialogAdd.visible=false"
      @change="addSignature"
    />
    <!-- 转签 人员配置 -->
    <choose-user-dialog-transfer
      v-if="chooseUserDialogTransfer.visible"
      :title="$t('CargoMsg.Cargo_SelectTransferor')"
      :visible.sync="chooseUserDialogTransfer.visible"
      :value="chooseUserDialogTransfer.userIds"
      @close="chooseUserDialogTransfer.visible=false"
      @change="transferSignature"
    />
  </div>
</template>
<script>

import ColumnUtils from '@/utils/ColumnUtils'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { convertDocument, getAddSignatureInfo, workflowAction, workflowCheck } from '@/api/workflow'
import { getLoading } from '@/utils/utilBaseElement'
import ProcessContent from '@/components/Cargo/Common/Wrokflow/processContent'
import { deleteFile, uploadStorage } from '@/api/storage'
import { cache, cacheName } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import DateUtils from '@/utils/dateUtils'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import {
  APPLICATION_DIMENSION_JOB_CHARGE,
  Job_CHARGE
} from '@/class/cargo/model/parameters/WorkflowConstants'
import ChargeDialog from '@/components/Cargo/Common/Wrokflow/chargeDialog'
import ChooseUserDialogAdd
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/chooseUserDialog'
import ChooseUserDialogTransfer
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/chooseUserDialog'
import URL from '@/api/urlTranslator'

export default {
  name: 'JobApplyDialog',
  components: { ProcessContent, cargoAdvanceSelect, ChargeDialog, ChooseUserDialogAdd, ChooseUserDialogTransfer },
  props: {
    title: { type: String, default: () => '' },
    processInfo: { type: Object, default: () => {} }, // 审核流程id
    type: { type: String, default: () => '' }, // apply-申请，look-查看，approve-审批
    status: { type: Number, default: () => null }, //
    records: { type: Array, default: () => [] }, // 审核记录
    visible: { type: Boolean, default: () => false },
    docId: { type: String, default: () => '' },
    documentConfigId: { type: Number, default: () => null }
  },
  data() {
    return {
      loading: null,
      form: {
        fileList: [],
        remark: ''
      },
      btnList: [],
      ColumnUtils: ColumnUtils,
      WorkflowUtil: WorkflowUtil,
      TYPE_NAMES: TYPE_NAMES,
      // showBillPaymentDialog: false,
      activeName: 'comments',
      approvalRemark: '',
      documentProcessId: '',
      storageURL: '',
      workflowName: '',
      receiveTypes: ClearingConstants.AMOUNT_RECEIVE_TYPES, // 收付方式源
      skipApprove: true, // 跳过审核，为了达到刚进来是不显示弹窗的效果，默认值为true；在check之后，若不跳过审核 或 未匹配到审批流，都将该值赋false，即不跳过审核，即显示审批弹窗
      CustomLableUtils: CustomLableUtils,
      job: {},
      showChargeDialog: false,
      chooseUserDialogAdd: {
        visible: false,
        userIds: []
      },
      chooseUserDialogTransfer: {
        visible: false,
        userId: null
      },
      btn: null
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    hasBtn() {
      return this.btnList && this.btnList.length > 0
    },
    isApply() {
      return this.type === 'apply'
    },
    isApprove() {
      return this.type === 'approve' && this.hasBtn
    },
    workflowTitle() {
      return this.workflowName || (this.processInfo ? this.processInfo.workflowName : '')
    },
    innerVisible: {
      get() {
        // 当提交时，skipApprove=true跳过审核，不展示弹窗
        return this.visible && (this.type === 'look' || !this.skipApprove)
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      }
    }
  },
  watch: {
  },
  beforeCreate() {
    // this.$options.components.BillPaymentDialog = BillPaymentDialog
  },
  async created() {
    // 初始化 业务费用 信息
    await convertDocument({ documentConfigId: this.documentConfigId, docId: this.docId }).then().then(res => {
      this.job = res.data
    })
    if (this.type !== 'look' || (this.processInfo && this.processInfo.state === 0)) {
      await this.init()
    }
    this.activeName = !this.isApprove ? 'record' : 'comments'
  },
  methods: {
    async init() {
      await cache.load(cacheName.CONFIG)
      this.storageURL = cache.config.get('StorageURL')
      const params = {
        documentConfigId: Job_CHARGE.code,
        docId: this.job.uuid,
        officeId: this.job.opOffice,
        documentProcessId: this.processInfo ? this.processInfo.documentProcessId : null
      }
      await workflowCheck(params).then(res => {
        if (res.data && res.data.skipApprove) {
          this.$message.success(this.$t('Message.CommitSuccessfully'))
          this.$emit('closeAndRefresh')
          return
        }
        this.skipApprove = false
        if (res.data && res.data.actions && res.data.actions.length > 0) {
          const btns = res.data.actions
          for (const btn of btns) {
            btn.color = btn.actionType > 7001 && [7008, 7011, 7012, 7013, 7014].indexOf(btn.actionType) === -1 ? 'danger' : 'primary'
            btn.title = btn.actionType === 7002 ? this.$t('CargoMsg.Cargo_RefuseTitle') : btn.actionType === 7006 ? this.$t('CargoMsg.Cargo_ReturnTitle') : ''
          }
          this.documentProcessId = res.data.documentProcessId
          this.workflowName = res.data.workflowName
          this.btnList = btns
        }
      }).catch(reason => {
        // 未匹配到审批流且抛异常时，不跳过审核
        this.skipApprove = false
      })
    },
    // 按钮动作
    onAction(btn) {
      this.btn = btn
      // 【加签动作】
      if (btn.actionType === 7011) {
        getAddSignatureInfo({ documentProcessId: this.documentProcessId }).then(res => {
          if (res.data.userIds && res.data.userIds.length > 0) {
            this.chooseUserDialogAdd.userIds = res.data.userIds
          }
          this.chooseUserDialogAdd.visible = true
        })
        return
      }
      // 【转签动作】
      if (btn.actionType === 7012) {
        this.chooseUserDialogTransfer.visible = true
        return
      }
      this.doAction(btn)
    },
    doAction(btn) {
      this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureToDo', [btn.actionName]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        this.loading = getLoading()
        await this.upload()
        const params = {
          documentConfigId: Job_CHARGE.code,
          docId: this.job.uuid,
          docNo: this.job.jobNo,
          actionId: btn.id,
          remark: this.form.remark,
          fileList: this.form.fileList,
          actionType: btn.actionType,
          officeId: this.job.opOffice,
          documentProcessId: this.documentProcessId,
          applicationDimension: APPLICATION_DIMENSION_JOB_CHARGE.code,
          signatureUserId: this.chooseUserDialogAdd.userIds && this.chooseUserDialogAdd.userIds.length > 0 ? this.chooseUserDialogAdd.userIds.join(',') : this.chooseUserDialogTransfer.userId,
          nodeId: !this.processInfo ? null : this.processInfo.nodeId
        }
        workflowAction(params).then(res => {
          this.$message.success(btn.actionName + this.$t('CargoMsg.Cargo_ApprovedSuccess'))
          this.$emit('closeAndRefresh')
        }).catch(reason => {
          // 操作失败 且存在附件的情况下，删除附件
          this.removeFile()
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    addSignature(userIds) {
      getAddSignatureInfo({ documentProcessId: this.documentProcessId }).then(res => {
        // 不允许对自己‘取消加签’
        if (res.data.userIds && res.data.userIds.length > 0) {
          if (res.data.userIds.indexOf(this.$store.getters.userId) !== -1 && userIds.indexOf(this.$store.getters.userId) === -1) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CancelAddSignature'))
            return
          }
        }
        // 不允许对自己‘加签’
        if ((!res.data.userIds || res.data.userIds.indexOf(this.$store.getters.userId) === -1) && userIds.indexOf(this.$store.getters.userId) !== -1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AddSignatureSelf'))
          return
        }
        // 不允许对‘已审批’或‘已委派’的人‘取消加签’
        if (res.data.fixUserIds && res.data.fixUserIds.length > 0) {
          for (const userId of res.data.fixUserIds) {
            if (userIds.indexOf(userId) === -1) {
              this.$message.warning(this.$t('CargoMsg.Cargo_CancelAddSignatureNotSupport'))
              return
            }
          }
        }
        // 会签下，不允许对当前节点人加签
        if (res.data.disableAddSignatureUserIds && res.data.disableAddSignatureUserIds.length > 0) {
          for (const userId of userIds) {
            if (res.data.disableAddSignatureUserIds.indexOf(userId) !== -1) {
              this.$message.warning(this.$t('CargoMsg.Cargo_AddSignatureCurrentNode'))
              return
            }
          }
        }
        this.chooseUserDialogAdd.visible = true
        this.chooseUserDialogAdd.userIds = userIds
        this.doAction(this.btn)
      })
    },
    transferSignature(userIds) {
      if (!userIds || userIds.length === 0) {
        return
      }
      // 只允许选择一个人‘转签人’
      if (userIds.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasOneOnly'))
        return
      }
      // 不允许选择自己作为‘转签人’
      if (userIds[0] === this.$store.getters.userId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_TransferSignatureSelf'))
        return
      }
      this.chooseUserDialogTransfer.visible = true
      this.chooseUserDialogTransfer.userId = userIds[0]
      this.doAction(this.btn)
    },
    handleClose() {
      this.innerVisible = false
      this.$emit('close')
    },
    // 查看付款申请单
    // onViewPaymentRequest() {
    //   this.showBillPaymentDialog = true
    // },
    // 上传附件
    async upload() {
      const rows = this.form.fileList.filter(p => !p.fileId)
      if (rows.length === 0) {
        return
      }
      try {
        await Promise.all(
          Array.from(rows, p => {
            const params = p
            params.documentType = 'workflow'
            return uploadStorage(params).then(res => {
              p.fileId = res.data
            })
          })
        )
      } catch {
        const uploadSuccessCount = rows.filter(p => p.fileId).length
        const uploadFailCount = rows.filter(p => !p.fileId).length
        await this.$confirm(
          `上传成功:${uploadSuccessCount}个,上传失败:${uploadFailCount}个.`,
          this.$t('common.tips.prompt'),
          {
            showClose: false,
            confirmButtonText: this.$t('common.btn.ok'),
            showCancelButton: false,
            type: 'warning'
          }
        )
      }
    },
    // 动作提交失败，则删除附件
    removeFile() {
      const rows = this.form.fileList.filter(p => p.fileId)
      if (rows.length === 0) {
        return
      }
      Promise.all(
        Array.from(rows, p => {
          return deleteFile(p.fileId).then(res => {
          })
        })
      )
    },
    downloadFile(fileId) {
      const url = `${URL.common.findByFileId}/${fileId}?sessionId=${this.$store.getters.token}`
      window.open(url)
    },
    lobLabel() {
      switch (this.job.lob) {
        case 'SE':
          return this.$t('CargoMsg.Cargo_OceanExport')
        case 'SI':
          return this.$t('CargoMsg.Cargo_OceanImport')
        case 'AE':
          return this.$t('CargoMsg.Cargo_AirExport')
        case 'AI':
          return this.$t('CargoMsg.Cargo_AirImport')
        case 'RE':
          return this.$t('CargoMsg.Cargo_RailwayExport')
        case 'RI':
          return this.$t('CargoMsg.Cargo_RailwayImport')
      }
    },
    dateLabel(date) {
      return DateUtils.formatStandardDate(date)
    },
    // paymentMethodLabel() {
    //   return this.labelName(this.billPayment.payType, this.receiveTypes)
    // },
    labelName(value, list) {
      const result = SystemConstants.getCommonState(value, list)
      if (!result) {
        return ''
      }
      return this.isZh ? result.chineseName : result.englishName
    },
    // 查看业务费用信息
    onViewChargeRequest() {
      this.showChargeDialog = true
    },
    getLoadTypeLabel() {
      if (this.job.lob === 'SE' || this.job.lob === 'SI') {
        return ColumnUtils.containerLoadTypeLabelFunction(this.job, 'containerLoadType')
      } else if (this.job.lob === 'AE' || this.job.lob === 'AI') {
        return ColumnUtils.operateTypeLabelFunc(this.job, 'containerLoadType')
      } else if (this.job.lob === 'RE' || this.job.lob === 'RI') {
        return ColumnUtils.containerLoadTypeLabelFunction(this.job, 'containerLoadType')
      }
      return ''
    },
    getLoadingPortLabel() {
      if (this.job.lob === 'SE' || this.job.lob === 'SI') {
        return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', this.job.loadingPortCode, 'auto_7')
      } else if (this.job.lob === 'AE' || this.job.lob === 'AI') {
        return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', this.job.loadingPortCode, 'auto_7')
      } else if (this.job.lob === 'RE' || this.job.lob === 'RI') {
        return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', this.job.loadingPortCode, 'auto_7')
      }
      return ''
    },
    getDischargingPortLabel() {
      if (this.job.lob === 'SE' || this.job.lob === 'SI') {
        return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', this.job.dischargingPortCode, 'auto_7')
      } else if (this.job.lob === 'AE' || this.job.lob === 'AI') {
        return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', this.job.dischargingPortCode, 'auto_7')
      } else if (this.job.lob === 'RE' || this.job.lob === 'RI') {
        return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', this.job.dischargingPortCode, 'auto_7')
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
  .job-apply-dialog{
    width: 100%;
    .el-dialog__footer{
      height: 65px;
    }
    h1{
      text-align: center;
    }
    tr{
      td {
        border: 1px solid #DCDFE6;
        padding: 5px;
        height: 35px;
        text-align: center;
        &.header {
          width: 15%;
          background-color: rgba(238, 248, 255, 1);
        }
        &.values {
          width: 35%;
          min-width: 100px;
        }
      }
    }
    .el-upload-dragger{
      margin-top: 10px;
      height: 40px;
      width: 130px;
      .el-icon-upload{
        margin: 15px 10px 16px !important;
        display: inline-block;
        font-size: 24px;
        line-height: 50px;
      }
    }
    .drop-uploader-icon{
      height: 100%; display: flex; align-items: center; justify-content: center;
    }
    .file-style{
      margin-top: 2px;
      width: 210px;
      height: 15px;
      background: linear-gradient(135deg,#f7faff, #ffffff);
      border-radius: 2px;
    }
    .file-name{
      width: 60%;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .el-input.el-input--mini {
      width: 100%;
      height: 100%;
      .el-input__inner{
        width: 100%;
        height: 100%;
      }
    }
    .el-input.el-input--mini.el-input--suffix{
      width: 100%;
      height: 100%;
      .el-input__inner{
        width: 100%;
        height: 100%;
      }
    }
    .el-select.el-select--mini{
      width: 100%;
      height: 100%;
      .el-input.el-input--mini.el-input--suffix{
        width: 100%;
        height: 100%;
        .el-input__inner{
          width: 100%;
          height: 100%;
        }
      }
    }
    .cargo-advance-select-wrapper{
      width: 100%;
      height: 100%;
      .el-select.el-select--mini{
        width: 100%;
        height: 100%;
        .el-input__inner{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>
